import { type PropsWithChildren, memo } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'

type DashboardLayoutProps = PropsWithChildren<{
  title: string
  right?: React.ReactNode
}>

export const DashboardLayout = memo(function DashboardLayout({
  title,
  right,
  children,
}: DashboardLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col p-4">
      <div className="mx-auto flex w-full max-w-[1200px] flex-1 flex-col">
        <Header />

        <main className="flex-1">
          <div className="mb-6 rounded-xl border border-border bg-card p-5">
            <h1 className="m-0 text-2xl font-semibold">{title}</h1>
            {right && <div className="mt-3">{right}</div>}
          </div>
          {children}
        </main>

        <Footer />
      </div>
    </div>
  )
})
